export class TextLinkDropdown extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['select']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.select?.exists) {
      this.listeners.add(
        this.els.select.element,
        'change',
        this.handleChange.bind(this),
      )
    }
  }

  handleChange (event) {
    const anchor = event.target.value
    const scrollToElement = document.querySelector(anchor)

    if (!scrollToElement) return

    scrollToElement.scrollIntoView()
  }
}

if (!customElements.get('text-link-dropdown')) {
  customElements.define('text-link-dropdown', TextLinkDropdown)
}
